import React from 'react';
import { Button } from 'react-bootstrap';
import './DangerButton.css';

const DangerButton = ({
  children,
  onClick,
  disabled = false,
  variant = 'danger',
  size = '',
  className = '',
  // Dynamic styling props with defaults
  width = 'fit-content',
  height = 'auto',
  padding = '0.6rem 1.2rem',
  fontSize = '14px',
  fontWeight = '600',
  borderRadius = 'var(--radius-sm)',
  backgroundColor = '#dc2626',
  borderColor = '#dc2626',
  color = 'white',
  hoverBackgroundColor = '#b91c1c',
  hoverBorderColor = '#b91c1c',
  hoverColor = 'white',
  boxShadow = 'none',
  hoverBoxShadow = '0 4px 8px rgba(220, 38, 38, 0.2)',
  transform = 'none',
  hoverTransform = '',
  transition = 'none',
  ...props
}) => {
  const dynamicStyle = {
    width,
    height,
    padding,
    fontSize,
    fontWeight,
    borderRadius,
    backgroundColor,
    borderColor,
    color,
    boxShadow,
    transform,
    transition,
    // CSS custom properties for hover states
    '--hover-bg': hoverBackgroundColor,
    '--hover-border': hoverBorderColor,
    '--hover-color': hoverColor,
    '--hover-shadow': hoverBoxShadow,
    '--hover-transform': hoverTransform
  };

  return (
    <Button
      className={`danger-btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      style={dynamicStyle}
      {...props}
    >
      {children}
    </Button>
  );
};

export default DangerButton;